// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ca14dfc","453":"a214e422","732":"ef29d23c","977":"6de3ecc8"}[chunkId] + ".chunk.js";
};